//Lesion : src/pages/REG/REG300F3.jsx

import React, {useState} from 'react';
import style from "./REG300F1.module.scss";
import styleCom from "./REGCOM.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import InputUnitText from "components/InputText/InputUnitText";
import TextArea from "components/TextArea/TextArea";
import Table from "components/Table/Table";
import {addDaysToDate, calcQcaDs, getDaysBetween} from './REGComUtil'; //
import SelectBox from "../../components/SelectBox/SelectBox";
import RadioGroup from "../../components/Radio/RadioGroup";
import Checkbox from "../../components/Checkbox/Checkbox";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil';

const RenderHtml = (props) => {

    const getLesionIndex = (contentId) => {
        switch(contentId) {
            case "T3": return 0; break;
            case "T4": return 1; break;
            case "T5": return 2; break;
            case "T6": return 3; break;
            default: return -1;
        }
    };
    const lesionIdx = getLesionIndex(props.contentId);

    const getLeDynamicCd = (key, index= lesionIdx) =>
        `M${(parseInt(key.slice(1)) + index * 1000).toString().padStart(5, '0')}`;

    const le000 = getLeDynamicCd('M01000'); //활성화 비활성화 기능(Lesion-1 은 사용불가)
    const le001 = getLeDynamicCd('M01001');
    const le002 = getLeDynamicCd('M01002');
    const le003 = getLeDynamicCd('M01003');
    const le004 = getLeDynamicCd('M01004');
    const le005 = getLeDynamicCd('M01005');
    const le006 = getLeDynamicCd('M01006');
    const le007 = getLeDynamicCd('M01007');
    const le008 = getLeDynamicCd('M01008');
    const le009 = getLeDynamicCd('M01009');
    const le010 = getLeDynamicCd('M01010');
    const le011 = getLeDynamicCd('M01011');
    const le012 = getLeDynamicCd('M01012');
    const le013 = getLeDynamicCd('M01013');
    const le014 = getLeDynamicCd('M01014');
    const le015 = getLeDynamicCd('M01015');
    const le016 = getLeDynamicCd('M01016');
    const le017 = getLeDynamicCd('M01017');
    const le018 = getLeDynamicCd('M01018');
    const le019 = getLeDynamicCd('M01019');
    const le020 = getLeDynamicCd('M01020');
    const le021 = getLeDynamicCd('M01021');
    const le022 = getLeDynamicCd('M01022');
    const le023 = getLeDynamicCd('M01023');
    const le024 = getLeDynamicCd('M01024');
    const le025 = getLeDynamicCd('M01025');
    const le026 = getLeDynamicCd('M01026');
    const le027 = getLeDynamicCd('M01027');
    const le028 = getLeDynamicCd('M01028');
    const le029 = getLeDynamicCd('M01029');
    const le030 = getLeDynamicCd('M01030');
    const le031 = getLeDynamicCd('M01031');
    const le032 = getLeDynamicCd('M01032');
    const le033 = getLeDynamicCd('M01033');
    const le034 = getLeDynamicCd('M01034');
    const le035 = getLeDynamicCd('M01035');
    const le036 = getLeDynamicCd('M01036');
    const le037 = getLeDynamicCd('M01037');
    const le038 = getLeDynamicCd('M01038');
    const le039 = getLeDynamicCd('M01039');
    const le040 = getLeDynamicCd('M01040');
    const le041 = getLeDynamicCd('M01041');  //Device 5
    const le042 = getLeDynamicCd('M01042');  //Device 5
    const le043 = getLeDynamicCd('M01043');  //Device 5
    const le044 = getLeDynamicCd('M01044');  //Device 5까지만 사용. 6삭제(사용중지)
    const le045 = getLeDynamicCd('M01045');  //Device 5까지만 사용. 6삭제(사용중지)
    const le046 = getLeDynamicCd('M01046');  //Device 5까지만 사용. 6삭제(사용중지)
    const le047 = getLeDynamicCd('M01047');
    const le048 = getLeDynamicCd('M01048');
    const le049 = getLeDynamicCd('M01049');
    const le050 = getLeDynamicCd('M01050');
    const le051 = getLeDynamicCd('M01051');
    const le052 = getLeDynamicCd('M01052');
    const le053 = getLeDynamicCd('M01053');
    const le054 = getLeDynamicCd('M01054');
    const le055 = getLeDynamicCd('M01055');
    const le056 = getLeDynamicCd('M01056');
    const le057 = getLeDynamicCd('M01057');
    const le058 = getLeDynamicCd('M01058');
    const le059 = getLeDynamicCd('M01059');
    const le060 = getLeDynamicCd('M01060');
    const le061 = getLeDynamicCd('M01061');
    const le062 = getLeDynamicCd('M01062');
    const le063 = getLeDynamicCd('M01063');
    const le064 = getLeDynamicCd('M01064');
    const le065 = getLeDynamicCd('M01065');
    const le066 = getLeDynamicCd('M01066');
    const le067 = getLeDynamicCd('M01067');
    const le068 = getLeDynamicCd('M01068');
    const le069 = getLeDynamicCd('M01069');
    const le070 = getLeDynamicCd('M01070');
    const le071 = getLeDynamicCd('M01071');
    const le072 = getLeDynamicCd('M01072');
    const le073 = getLeDynamicCd('M01073');
    const le074 = getLeDynamicCd('M01074');
    const le075 = getLeDynamicCd('M01075');
    const le076 = getLeDynamicCd('M01076');


    let lesion1Html=<></>;

    const radioOptions = [
         {mapCd: le015, value: "1", label: "De Novo"}, {mapCd: le015, value: "2", label: "ISR"}
        ,{mapCd: le016, value: "1", label: "None"}, {mapCd: le016, value: "2", label: "Mild"}
        ,{mapCd: le016, value: "3", label: "Moderate"}, {mapCd: le016, value: "4", label: "Severe"}
        ,{mapCd: le017, value: "1", label: "None"}, {mapCd: le017, value: "2", label: "Mild"}
        ,{mapCd: le017, value: "3", label: "Moderate"}, {mapCd: le017, value: "4", label: "Severe"}
        ,{mapCd: le018, value: "1", label: "None"}, {mapCd: le018, value: "2", label: "Mild"}
        ,{mapCd: le018, value: "3", label: "Moderate"}, {mapCd: le018, value: "4", label: "Severe"}
        ,{mapCd: le019, value: "1", label: "No"}, {mapCd: le019, value: "2", label: "Yes"}
        ,{mapCd: le020, value: "1", label: "No"}, {mapCd: le020, value: "2", label: "Yes"}
        ,{mapCd: le021, value: "1", label: "No"}, {mapCd: le021, value: "2", label: "Yes"}
        ,{mapCd: le022, value: "1", label: "No"}, {mapCd: le022, value: "2", label: "CTO(<3Mo)"}
        ,{mapCd: le022, value: "3", label: "CTO(>3Mo or unknown)"}
        ,{mapCd: le023, value: "1", label: "<50%"},   {mapCd: le023, value: "2", label: "50~70%"}
        ,{mapCd: le023, value: "3", label: ">70~99%"},{mapCd: le023, value: "4", label: "Total occlusion"}
        ,{mapCd: le024, value: "1", label: "TIMI-0"}, {mapCd: le024, value: "2", label: "TIMI-1"}
        ,{mapCd: le024, value: "3", label: "TIMI-2"}, {mapCd: le024, value: "4", label: "TIMI-3"}
        ,{mapCd: le025, value: "1", label: "A"}, {mapCd: le025, value: "2", label: "B1"}
        ,{mapCd: le025, value: "3", label: "B2"}, {mapCd: le025, value: "4", label: "C"}
        ,{mapCd: le029, value: "1", label: "EluNIR™"}, {mapCd: le029, value: "2", label: "EluNIR-PERL™"}
        ,{mapCd: le032, value: "1", label: "EluNIR™"}, {mapCd: le032, value: "2", label: "EluNIR-PERL™"}
        ,{mapCd: le035, value: "1", label: "EluNIR™"}, {mapCd: le035, value: "2", label: "EluNIR-PERL™"}
        ,{mapCd: le038, value: "1", label: "EluNIR™"}, {mapCd: le038, value: "2", label: "EluNIR-PERL™"}
        ,{mapCd: le041, value: "1", label: "EluNIR™"}, {mapCd: le041, value: "2", label: "EluNIR-PERL™"}
        ,{mapCd: le047, value: "1", label: "No"}, {mapCd: le047, value: "2", label: "Yes"}
        ,{mapCd: le048, value: "1", label: "Not done"}, {mapCd: le048, value: "2", label: "Pre-PCI"}
        ,{mapCd: le048, value: "3", label: "Post-PCI"}, {mapCd: le048, value: "4", label: "Both"}
        ,{mapCd: le049, value: "1", label: "Not done"}, {mapCd: le049, value: "2", label: "Pre-PCI"}
        ,{mapCd: le049, value: "3", label: "Post-PCI"}, {mapCd: le049, value: "4", label: "Both"}
        ,{mapCd: le050, value: "1", label: "Not done"}, {mapCd: le050, value: "2", label: "Pre-PCI"}
        ,{mapCd: le050, value: "3", label: "Post-PCI"}, {mapCd: le050, value: "4", label: "Both"}
        ,{mapCd: le051, value: "1", label: "No"}, {mapCd: le051, value: "2", label: "Yes"}
        ,{mapCd: le052, value: "1", label: "No"}, {mapCd: le052, value: "2", label: "Yes"}
        ,{mapCd: le053, value: "1", label: "1. Single stent without SB ballooning"}
        ,{mapCd: le053, value: "2", label: "2. Single stent with SB ballooning"}
        ,{mapCd: le053, value: "3", label: "3. Two stents"}
        ,{mapCd: le054, value: "1", label: "1. Classic T stenting"}
        ,{mapCd: le054, value: "2", label: "2. Provisional T stenting"}
        ,{mapCd: le054, value: "3", label: "3. Crush Technique"}
        ,{mapCd: le054, value: "4", label: "4. Mini-Crush Technique"}
        ,{mapCd: le054, value: "5", label: "5. Culotte technique"}
        ,{mapCd: le054, value: "6", label: "6. TAP technique"}
        ,{mapCd: le054, value: "7", label: "7. Kissing Stenting"}
        ,{mapCd: le054, value: "8", label: "8. Vstenting"}
        ,{mapCd: le054, value: "9", label: "9. Other"}
        ,{mapCd: le057, value: "1", label: "No"}, {mapCd: le057, value: "2", label: "Yes"}
        ,{mapCd: le058, value: "1", label: "1. Antegrade Approach"}
        ,{mapCd: le058, value: "2", label: "2. Retrograde Approach"}
        ,{mapCd: le058, value: "3", label: "3. Dissection / Re-entry"}
        ,{mapCd: le058, value: "4", label: "4. Hybrid Approach"}
        ,{mapCd: le059, value: "1", label: "1. Single wire technique"}
        ,{mapCd: le059, value: "2", label: "2. Paraller wire"}
        ,{mapCd: le059, value: "3", label: "3. Seesaw wire"}
        ,{mapCd: le059, value: "4", label: "4. CART"}
        ,{mapCd: le059, value: "5", label: "5. Reverse CART"}
        ,{mapCd: le059, value: "6", label: "6. IVUS guided"}
        ,{mapCd: le061, value: "1", label: "No"}, {mapCd: le061, value: "2", label: "Yes"}
        ,{mapCd: le071, value: "1", label: "Successful PCI"}, {mapCd: le071, value: "2", label: "Suboptimal PCI"}
        ,{mapCd: le072, value: "1", label: "TIMI-0"}, {mapCd: le072, value: "2", label: "TIMI-1"}
        ,{mapCd: le072, value: "3", label: "TIMI-2"}, {mapCd: le072, value: "4", label: "TIMI-3"}

 

    ];

    const transformCdValues = () => {
        const newData = radioOptions.map(item => {
            const cdNumber = parseInt(item.mapCd.substring(1), 10);
            const newCdNumber = cdNumber + 204;
            const newCd = `M${String(newCdNumber).padStart(5, '0')}`; // 숫자가 5자리 되도록 앞에 0 채움
            return { ...item, mapCd: newCd };
        });
        console.log(newData);

    };


    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }

    const activeFlagObj = props.activeFlagObj;

    const btnAllObj = [
         {mapCd: "M00029", tarId:"M00031", tarVal:"2"},{mapCd: "M00029", tarId:"M00032", tarVal:"2"}


    ];

    const activeEvent = (mapCd, value="") =>{
        /* activeEvent :
         * - 이벤트 발생시 코드와 값을 기준으로 컴포넌트 활성화/비활성화를 제어하는 상태값 변경
         * - 데이터가 존재하는 activeFlag 필드 값을 변경하여 제어( readOlny 같은 옵션에서 값을 참조하는방식)
         */
        const matchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='matched' && item.chkVal === value
        );
        const notMatchedObj = activeFlagObj.filter(item =>
            item.mapCd === mapCd && item.chkFlag==='notMatched'
        );

        if(matchedObj.length > 0){
            matchedObj.forEach(item => {
                if(matchedObj.length > 0 && item.chkVal === value){
                    props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                    props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
                }
            });
        }else if(notMatchedObj.length > 0){
            notMatchedObj.forEach(item => {
                props.setDtlValue(item.tarId, item.tarFlag, 'activeFlag');
                props.setDtlValue(item.tarId, item.tarVal, 'itmRslt');
            });
        }

        /* Final QCA, 잔여협착(DS) 계산 ※ value로 가져와야 실시간 현재값 확인가능
        * ******************************* */
        if(mapCd===le073){
            props.setDtlValue(le075,calcQcaDs(value, props.getDtlValue(le074)) );
        }else if(mapCd===le074) {
            props.setDtlValue(le075,calcQcaDs(props.getDtlValue(le073), value) );
        }else if(mapCd===le027) {
            props.setDtlValue(le075,calcQcaDs(props.getDtlValue(le073), value) );
        }

    }

    const btnAllEvent = (mapCd) => {
        /* 일괄 선택 처리 */
        const allObj = btnAllObj.filter(item => item.mapCd === mapCd);
         if (allObj.length > 0) {
             allObj.forEach(item => {
                 props.setDtlValue(item.tarId, item.tarVal);
                 activeEvent(item.tarId, item.tarVal);
            });
        }
    };

    /* Used DES device 처리 ****************************************************************************** */

    const generateItems = (inputCode, itemCount = 15) => {
        const letterPart = inputCode.charAt(0); // 문자 1자리 추출
        const numberPart = parseInt(inputCode.slice(1), 10); // 숫자 5자리 추출 후 숫자로 변환
        const startNumber = numberPart + 1; // 숫자 부분을 1 증가한 값부터 시작

        let items = [];
        let index = 1; // 처음 index는 1
        let count = 0; // 그룹 내 개수 카운트 (3개씩 반복)

        for (let i = 0; i < itemCount; i++) {
            const code = `${letterPart}${String(startNumber + i).padStart(5, "0")}`; // 숫자는 5자리 유지

            items.push({ code, index });

            // 3개씩 묶어서 index 증가
            if (count < 2) {
                count++;
            } else {
                count = 0; // 3번째 아이템에서 count 초기화
                index++; // index 증가
            }
        }

        return items;
    };



    const addUsedDes = (tarMapCd) => {
        let tarValue = props.getDtlValue(tarMapCd);
        if (tarValue === null || tarValue === "" || tarValue === NaN) {
            tarValue = "0";
        }

        tarValue = String(parseInt(tarValue) + 1);
        props.initialItemState(tarMapCd, tarValue);


        if(parseInt(tarValue)>5){
             toast({ type: 'info', message: "최대 5개까지만 등록이 가능합니다." });
             return;
        }
        props.setDtlValue(tarMapCd, tarValue);

    };

    const removeUsedDes = (tarMapCd) => {
        const deviceObj =  generateItems(tarMapCd);

        let tarValue = props.getDtlValue(tarMapCd);

        if (tarValue === null || tarValue === "" || tarValue === NaN) {
            return;
        } else {
            const removeIndex = parseInt(tarValue);
            tarValue = String(removeIndex - 1);

            deviceObj.forEach(item => {
                if (item.index === removeIndex) {
                    props.setDtlValue(item.code, "");
                }
            });

            props.initialItemState(tarMapCd, tarValue);

            if(parseInt(tarValue)>-1)
            {
                if(parseInt(tarValue)===0 || tarValue === NaN || tarValue === null ) {
                    tarValue = "";
                }
                props.setDtlValue(tarMapCd, tarValue);
            }
        }





        // if(parseInt(tarValue)===0){
        //     //toast({ type: 'info', message: "최대 5개까지만 등록이 가능합니다." });
        //     return;
        // }

    };



    /* Event ****************************************************************************** */

    const compValue = (mpaCd) => {
        return props.getDtlValue(mpaCd);
    }

    const compChange = (mapCd, value) => {

        props.setDtlValue(mapCd, value);
        activeEvent(mapCd, value);

        /* Lesion 추가이벤트 처리
         * MLD(le026), RVD(le027) 입력시 하단의 MLD(le073),RVD(le074)도 같이 입력
        switch (mapCd) {
            case le027:
                props.setDtlValue(le074, value);
                break;
            default:
                break;
        }
        */




    }

    /* ****************************************************************************** Event */

    const insertSpace = (index) => {
        return new Array(index).fill("\u00A0").map((space, idx) => (
            <span key={idx}>{space}</span>
        ));
    };


    lesion1Html =
        <>
{/*<button onClick={transformCdValues}>CD 값 변환</button>*/}
            <div className={styleCom.title_wrap}>
                <div style={{display: "flex", gap: "10px"}}>
                    <h3>[Lesion - {lesionIdx + 1}] Lesion Characteristics</h3>
                    <div style={{visibility: lesionIdx===0? 'hidden' : 'visible' }}>
                        <Checkbox label={"해당없음 (N/D)"}
                                  onChange={(e) => compChange(le000, e.target.checked ? '1' : '0')}
                                  checked={props.getDtlValue(le000) === '1'} marginTop={"5px"}
                        />
                    </div>
                </div>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={16} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>
                        Procedure date
                    </div>
                    <div>
                        <DatePicker selDate={ymdToDate(props.getDtlValue(le076))}
                                    dateFormat={'yyyy-MM-dd'}
                                    onChange={(date) => props.setDtlValue(le076, dateToYMD(date))}/>
                    </div>
                    <div>Lesion segment</div>
                    <div>
                        <table style={{margin: "8px 0 8px 0"}}>
                            <tbody>
                            <tr>
                                <td className={style.cellFlex}>
                                    <Checkbox label={"Left main"}
                                              onChange={(e) => props.setDtlValue(le001, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le001) === '1'}/>
                                </td>
                            </tr>
                            <tr>
                                <td className={style.cellFlex}>
                                    <Checkbox label={"proximal LAD"}
                                              onChange={(e) => props.setDtlValue(le002, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le002) === '1'}/>
                                    <Checkbox label={"mid LAD"}
                                              onChange={(e) => props.setDtlValue(le003, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le003) === '1'}/>
                                    <Checkbox label={"distal LAD"} marginLeft={"10px"}
                                              onChange={(e) => props.setDtlValue(le004, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le004) === '1'}/>
                                    <Checkbox label={"Diagonal branch"}
                                              onChange={(e) => props.setDtlValue(le005, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le005) === '1'}/>

                                </td>
                            </tr>
                            <tr>
                                <td className={style.cellFlex}>
                                    <Checkbox label={"proximal LCX"}
                                              onChange={(e) => props.setDtlValue(le006, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le006) === '1'}/>
                                    <Checkbox label={"distal LCX"} marginLeft={"2px"}
                                              onChange={(e) => props.setDtlValue(le007, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le007) === '1'}/>
                                    <Checkbox label={"Obtuse marginal branch"}
                                              onChange={(e) => props.setDtlValue(le008, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le008) === '1'}/>
                                    <Checkbox label={"Ramus"}
                                              onChange={(e) => props.setDtlValue(le009, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le009) === '1'}/>
                                </td>
                            </tr>
                            <tr>
                                <td className={style.cellFlex}>
                                    <Checkbox label={"proximal RCA"}
                                              onChange={(e) => props.setDtlValue(le010, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le010) === '1'}/>
                                    <Checkbox label={"mid RCA"}
                                              onChange={(e) => props.setDtlValue(le011, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le011) === '1'}/>
                                    <Checkbox label={"distal RCA"} marginLeft={"9px"}
                                              onChange={(e) => props.setDtlValue(le012, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le012) === '1'}/>
                                    <Checkbox label={"PL"}
                                              onChange={(e) => props.setDtlValue(le013, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le013) === '1'}/>
                                    <Checkbox label={"PDA"}
                                              onChange={(e) => props.setDtlValue(le014, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le014) === '1'}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>ISR or De Novo</div>
                    <div>
                        <RadioGroup options={getOptionList(le015)} selectedValue={compValue(le015)}
                                    onChange={(val) => props.setDtlValue(le015, val)}/>
                    </div>
                    <div>Prox.tortuosity</div>
                    <div>
                        <RadioGroup options={getOptionList(le016)} selectedValue={compValue(le016)}
                                    onChange={(val) => props.setDtlValue(le016, val)}/>
                    </div>
                    <div>Angulation</div>
                    <div>
                        <RadioGroup options={getOptionList(le017)} selectedValue={compValue(le017)}
                                    onChange={(val) => props.setDtlValue(le017, val)}/>
                    </div>
                    <div>Calcification</div>
                    <div>
                        <RadioGroup options={getOptionList(le018)} selectedValue={compValue(le018)}
                                    onChange={(val) => props.setDtlValue(le018, val)}/>
                    </div>
                    <div>AMI culprit</div>
                    <div>
                        <RadioGroup options={getOptionList(le019)} selectedValue={compValue(le019)}
                                    onChange={(val) => props.setDtlValue(le019, val)}/>
                    </div>
                    <div>Thrombus</div>
                    <div>
                        <RadioGroup options={getOptionList(le020)} selectedValue={compValue(le020)}
                                    onChange={(val) => props.setDtlValue(le020, val)}/>
                    </div>
                    <div>Bifurcation or Trifurcation(SB>1.5mm)</div>
                    <div>
                        <RadioGroup options={getOptionList(le021)} selectedValue={compValue(le021)}
                                    onChange={(val) => props.setDtlValue(le021, val)}/>
                    </div>
                    <div>CTO</div>
                    <div>
                        <RadioGroup options={getOptionList(le022)} selectedValue={compValue(le022)}
                                    onChange={(val) => props.setDtlValue(le022, val)}/>
                    </div>
                    <div>Diameter Stenosis,QCA</div>
                    <div>
                        <RadioGroup options={getOptionList(le023)} selectedValue={compValue(le023)}
                                    onChange={(val) => props.setDtlValue(le023, val)}/>
                    </div>
                    <div>TIMI flow grade</div>
                    <div>
                        <RadioGroup options={getOptionList(le024)} selectedValue={compValue(le024)}
                                    onChange={(val) => props.setDtlValue(le024, val)}/>
                    </div>
                    <div>ACC/AHA Lesion class</div>
                    <div>
                        <RadioGroup options={getOptionList(le025)} selectedValue={compValue(le025)}
                                    onChange={(val) => props.setDtlValue(le025, val)}/>
                    </div>
                    <div>최소내강직경(MLD, mm)</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue(le026)} unit={"mm"}
                                       onChange={(value) => compChange(le026, value)}/>
                    </div>
                    <div>참조혈관의 직경(RVD, mm)</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue(le027)} unit={"mm"}
                                       onChange={(value) => compChange(le027, value)}/>
                    </div>
                    <div>Total number of stents at this lesion</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue(le028)} unit={"ea"}
                                       readOnly={true}/>
                        <div style={{display: "flex", gap: "10px", height: "100%", marginTop: "15px"}}>
                            <Button variant="Primary" addStyle={{width: "60px", height: "40px"}}
                                    onClick={() => addUsedDes(le028)}>+</Button>
                            <Button variant="Secondary" addStyle={{width: "60px", height: "40px"}}
                                    onClick={() => removeUsedDes(le028)}>
                                -</Button>
                        </div>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Used DES device</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='Vertical' rowCnt={6} colSize={['7%', '31%', '31%', '31%']} rowSize={'56px'}>
                    <div>No</div>
                    <div>Device name</div>
                    <div>Diameter(mm)</div>
                    <div>Length(mm)</div>
                    <div>1</div>
                    <div style={{justifyContent: "left"}}>
                        <RadioGroup options={getOptionList(le029)} selectedValue={compValue(le029)}
                                    onChange={(val) => props.setDtlValue(le029, val)}
                                    disabled={props.getDtlValue(le029, 'activeFlag')}/>

                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le030)} unit={"mm"}
                                       onChange={(value) => compChange(le030, value)}
                                       readOnly={props.getDtlValue(le030, 'activeFlag')}/>
                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le031)} unit={"mm"}
                                       onChange={(value) => compChange(le031, value)}
                                       readOnly={props.getDtlValue(le031, 'activeFlag')}/>
                    </div>
                    <div>2</div>
                    <div style={{justifyContent: "left"}}>
                        <RadioGroup options={getOptionList(le032)} selectedValue={compValue(le032)}
                                    onChange={(val) => props.setDtlValue(le032, val)}
                                    disabled={props.getDtlValue(le032, 'activeFlag')}/>

                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le033)} unit={"mm"}
                                       onChange={(value) => compChange(le033, value)}
                                       readOnly={props.getDtlValue(le033, 'activeFlag')}/>
                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le034)} unit={"mm"}
                                       onChange={(value) => compChange(le034, value)}
                                       readOnly={props.getDtlValue(le034, 'activeFlag')}/>
                    </div>
                    <div>3</div>
                    <div style={{justifyContent: "left"}}>
                        <RadioGroup options={getOptionList(le035)} selectedValue={compValue(le035)}
                                    onChange={(val) => props.setDtlValue(le035, val)}
                                    disabled={props.getDtlValue(le035, 'activeFlag')}/>

                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le036)} unit={"mm"}
                                       onChange={(value) => compChange(le036, value)}
                                       readOnly={props.getDtlValue(le036, 'activeFlag')}/>
                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le037)} unit={"mm"}
                                       onChange={(value) => compChange(le037, value)}
                                       readOnly={props.getDtlValue(le037, 'activeFlag')}/>
                    </div>
                    <div>4</div>
                    <div style={{justifyContent: "left"}}>
                        <RadioGroup options={getOptionList(le038)} selectedValue={compValue(le038)}
                                    onChange={(val) => props.setDtlValue(le038, val)}
                                    disabled={props.getDtlValue(le038, 'activeFlag')}/>

                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le039)} unit={"mm"}
                                       onChange={(value) => compChange(le039, value)}
                                       readOnly={props.getDtlValue(le039, 'activeFlag')}/>
                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le040)} unit={"mm"}
                                       onChange={(value) => compChange(le040, value)}
                                       readOnly={props.getDtlValue(le040, 'activeFlag')}/>
                    </div>
                    <div>5</div>
                    <div style={{justifyContent: "left"}}>
                        <RadioGroup options={getOptionList(le041)} selectedValue={compValue(le041)}
                                    onChange={(val) => props.setDtlValue(le041, val)}
                                    disabled={props.getDtlValue(le041, 'activeFlag')}/>

                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le042)} unit={"mm"}
                                       onChange={(value) => compChange(le042, value)}
                                       readOnly={props.getDtlValue(le042, 'activeFlag')}/>
                    </div>
                    <div style={{justifyContent: "left"}}>
                        <InputUnitText type={"number"} value={props.getDtlValue(le043)} unit={"mm"}
                                       onChange={(value) => compChange(le043, value)}
                                       readOnly={props.getDtlValue(le043, 'activeFlag')}/>
                    </div>


                </Table>
            </div>


            <div className={styleCom.title_wrap}>
                <h3>Procedure Data</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={10} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>Thrombus aspiration</div>
                    <div>
                        <RadioGroup options={getOptionList(le047)} selectedValue={compValue(le047)}
                                    onChange={(val) => props.setDtlValue(le047, val)}
                                    disabled={props.getDtlValue(le047, 'activeFlag')}/>
                    </div>
                    <div>IVUS evaluation</div>
                    <div>
                        <RadioGroup options={getOptionList(le048)} selectedValue={compValue(le048)}
                                    onChange={(val) => props.setDtlValue(le048, val)}
                                    disabled={props.getDtlValue(le048, 'activeFlag')}/>
                    </div>
                    <div>OCT evaluation</div>
                    <div>
                        <RadioGroup options={getOptionList(le049)} selectedValue={compValue(le049)}
                                    onChange={(val) => props.setDtlValue(le049, val)}
                                    disabled={props.getDtlValue(le049, 'activeFlag')}/>
                    </div>
                    <div>FFR</div>
                    <div>
                        <RadioGroup options={getOptionList(le050)} selectedValue={compValue(le050)}
                                    onChange={(val) => props.setDtlValue(le050, val)}
                                    disabled={props.getDtlValue(le050, 'activeFlag')}/>
                    </div>
                    <div>Rotablator Atherectomy</div>
                    <div>
                        <RadioGroup options={getOptionList(le051)} selectedValue={compValue(le051)}
                                    onChange={(val) => props.setDtlValue(le051, val)}
                                    disabled={props.getDtlValue(le051, 'activeFlag')}/>
                    </div>
                    <div>Bifurcation PCI</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList(le052)}
                                                selectedValue={props.getDtlValue(le052)}
                                                onChange={(val) => compChange(le052, val)}
                                                disabled={props.getDtlValue(le052, 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes, Method of SB Tx
                                    <SelectBox
                                        options={getOptionList(le053)} valueKey="value" labelKey="label"
                                        value={props.getDtlValue(le053)}
                                        onChange={(val) => compChange(le053, val)}
                                        width={'30%'} isDisabled={props.getDtlValue(le053, 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If two stents, select technique
                                    <SelectBox
                                        options={getOptionList(le054)}
                                        valueKey="value" labelKey="label"
                                        value={props.getDtlValue(le054)}
                                        onChange={(val) => props.setDtlValue(le054, val)}
                                        width={'30%'} isDisabled={props.getDtlValue(le054, 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Checkbox label={"Final Kissing balloon"}
                                              onChange={(e) => props.setDtlValue(le055, e.target.checked ? '1' : '0')}
                                              checked={props.getDtlValue(le055) === '1'}
                                              isDisabled={props.getDtlValue(le055, 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Comment
                                    <TextArea value={props.getDtlValue(le056)}
                                              onChange={(val) => props.setDtlValue(le056, val)}
                                              placeholder={"코멘트를 작성해 주세요"} margin={"5px auto"}
                                              disabled={props.getDtlValue(le056, 'activeFlag')} height={"80px"}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>CTO PCI</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList(le057)} selectedValue={compValue(le057)}
                                                onChange={(val) => compChange(le057, val)}
                                                disabled={props.getDtlValue(le057, 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes, Approach Method
                                    <SelectBox
                                        options={getOptionList(le058)}
                                        valueKey="value" labelKey="label"
                                        value={props.getDtlValue(le058)}
                                        onChange={(val) => compChange(le058, val)}
                                        isDisabled={props.getDtlValue(le058, 'activeFlag')}
                                        width={'30%'}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    CTO Technique
                                    <SelectBox
                                        options={getOptionList(le059)}
                                        valueKey="value" labelKey="label"
                                        value={props.getDtlValue(le059)}
                                        onChange={(val) => props.setDtlValue(le059, val)}
                                        width={'30%'} isDisabled={props.getDtlValue(le059, 'activeFlag')}/>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Comment</p>
                                    <TextArea value={props.getDtlValue(le060)} height={"80px"}
                                              onChange={(val) => props.setDtlValue(le060, val)}
                                              placeholder={"코멘트를 작성해 주세요"} margin={"5px auto"}
                                              disabled={props.getDtlValue(le060, 'activeFlag')}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Complication during the procedure</div>
                    <div>
                        <table className={style.customLine} style={{height: "56px"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <RadioGroup options={getOptionList(le061)} selectedValue={compValue(le061)}
                                                onChange={(val) => compChange(le061, val)}
                                                />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    If Yes,
                                    <div style={{display: "flex", gap: "10px", marginTop: "15px"}}>
                                        <Checkbox label={"No reflow"}
                                                  onChange={(e) => props.setDtlValue(le062, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le062) === '1'}
                                                  isDisabled={props.getDtlValue(le062, 'activeFlag')}/>
                                        <Checkbox label={"Distal embolization"}
                                                  onChange={(e) => props.setDtlValue(le063, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le063) === '1'}
                                                  isDisabled={props.getDtlValue(le063, 'activeFlag')}/>
                                        <Checkbox label={"Acute closure"}
                                                  onChange={(e) => props.setDtlValue(le064, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le064) === '1'}
                                                  isDisabled={props.getDtlValue(le064, 'activeFlag')}/>
                                        <Checkbox label={"Dissection (after stenting)"}
                                                  onChange={(e) => props.setDtlValue(le065, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le065) === '1'}
                                                  isDisabled={props.getDtlValue(le065, 'activeFlag')}/>
                                    </div>
                                    <div style={{display: "flex", gap: "10px", marginTop: "5px"}}>
                                        <Checkbox label={"Side branch occlusion"}
                                                  onChange={(e) => props.setDtlValue(le066, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le066) === '1'}
                                                  isDisabled={props.getDtlValue(le066, 'activeFlag')}/>
                                        <Checkbox label={"Perforation"}
                                                  onChange={(e) => props.setDtlValue(le067, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le067) === '1'}
                                                  isDisabled={props.getDtlValue(le067, 'activeFlag')}/>
                                        <Checkbox label={"Intraprocedural stent thrombosis"}
                                                  onChange={(e) => props.setDtlValue(le068, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le068) === '1'}
                                                  isDisabled={props.getDtlValue(le068, 'activeFlag')}/>
                                        <Checkbox label={"Other"}
                                                  onChange={(e) => compChange(le069, e.target.checked ? '1' : '0')}
                                                  checked={props.getDtlValue(le069) === '1'}
                                                  isDisabled={props.getDtlValue(le069, 'activeFlag')}/>
                                        <div><InputUnitText type={"text"} value={props.getDtlValue(le070)}
                                                            maxLength={30}
                                                            onChange={(value) => props.setDtlValue(le070, value)}
                                                            readOnly={props.getDtlValue(le070, 'activeFlag')}/>
                                        </div>
                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>Result of PCI</div>
                    <div>
                        <RadioGroup options={getOptionList(le071)} selectedValue={compValue(le071)}
                                    onChange={(val) => props.setDtlValue(le071, val)}/>
                    </div>
                    <div>Final TIMI</div>
                    <div>
                        <RadioGroup options={getOptionList(le072)} selectedValue={compValue(le072)}
                                    onChange={(val) => props.setDtlValue(le072, val)}/>
                    </div>
                </Table>
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Post procedural results</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={3} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>최소내강직경(MLD,mm)</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue(le073)} unit={"mm"}
                                       onChange={(value) => compChange(le073, value)}
                                       readOnly={props.getDtlValue(le073, 'activeFlag')}/>
                    </div>
                    <div>참조혈관의 직경(RVD, mm)</div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue(le074)} unit={"mm"}
                                       onChange={(value) => compChange(le074, value)}
                                       readOnly={props.getDtlValue(le074, 'activeFlag')}/>
                    </div>
                    <div>
                        <span className={style.cellText2}>
                            <div className={style.cellText1}>Final QCA, 잔여협착(DS,%)</div>
                            ( 1-[MLD/RVD] ) x 100 </span>
                    </div>
                    <div>
                        <InputUnitText type={"text"} value={props.getDtlValue(le075)} unit={"%"}
                                       onChange={(value) => props.setDtlValue(le075, value)}
                                       readOnly={props.getDtlValue(le075, 'activeFlag')}/>
                    </div>
                </Table>
            </div>

        </>;


    const renderHtmlDisable =
        <div style={{display: "flex", gap: "10px"}}>
            <h3>[Lesion - {lesionIdx + 1}] 사용시 체크를 해제하여 주십시오.</h3>
            <Checkbox label={"해당없음 (N/D)"}
                      onChange={(e) => compChange(le000, e.target.checked ? '1' : '0')}
                      checked={props.getDtlValue(le000) === '1'}/>
        </div>
    ;
    let renderHtml =
        <></>
    ;
    switch(props.contentId) {
        case "T3":
            renderHtml = lesion1Html;
        break;
        case "T4": case "T5": case "T6":
            if(props.getDtlValue(le000) === '1'){
                renderHtml = renderHtmlDisable;
            }else{
                renderHtml = lesion1Html;
            }
        break;
        default:
            renderHtml = <h3>페이지를 확인할 수 없습니다. 서비스를 다시시작하여 주십시오.</h3>;
        break;
    }

    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

